module.exports = __webpack_public_path__ + "img/image-thumb-10.a40bd910.jpg";